import { EnvironmentType } from "../app/shared/constants/environment-enum";

export const environment = {
    type: EnvironmentType.Development,
    production: false,
    superSetUrl: 'https://pca154.web2.anasource.com:8088/',
    serverUrl: '  https://tpaapi.anasource.com/', // Anasource WEB2 Database
    // serverUrl: 'https://localhost:44382/', // LOCAL DEVELOPMENT Databse
    keyCloakConfig: {
        authClientId: 'TPA_Development',
    },
    publicKey: `-----BEGIN PUBLIC KEY-----
    MIIBITANBgkqhkiG9w0BAQEFAAOCAQ4AMIIBCQKCAQBqMfNqVjvOuVegfxjTqDNP
    QxavScm7LU84ThLhS3ZaaRindJ/obtp8gbf/kDfByzioaHSGiMpGBHZecIg9l1Yk
    xcUcGkb11w3gXVPKXxTdjJMLCIpOSrwv2SqARekWt4D1GWhV8PHd6jZc6tsJMqxU
    vCJjdc3vga5AjYUmpNyCDfLMwPYFEJlIaWgX0ONyBAKihOcLv8uw//cLPYKzl47o
    kJ3covxsUazKaSxwtraUsNSQei1x0leVJ4oLeQ9qy/Ca+7EzyyT+E6eIcy7XT9Cq
    BdLuhRFQT8RdADmhe+xNfYv/MIiF6NkTkqjkMS0aDzNXnF5FIxyy/49UPG41cf/P
    AgMBAAE=
    -----END PUBLIC KEY-----`,
    OTPExpirationIntervalInMinute: 10,
    DiagnosisType: {
        Principle: '745d4107-4b00-45bb-814c-535fdf16b968',
        Secondary: 'ce8704d9-9312-4ac4-82d2-919d4e41a753',
        Admitting: 'e03f3d1e-5eac-4258-8204-c24560fcdff4',
        Discharge: '9bf97f56-e7fb-45e5-89e9-97da6ccbac91',
        Differntial: '6566288c-219d-428a-b71d-1a670e8cbdce'
    },
    ClaimType: {
        Dental: '7a897715-844f-4279-b00c-9076b033df00',
        Institutional: 'b9f28091-bbae-4ef9-858e-a9483ca72d46',
        Optical: '1bcbfe5e-260e-4db6-8014-a94c680389e3',
        Pharmacy: 'ece3597a-4377-44a0-a939-447e447538a2',
        Professional: '6fc4332b-2ae3-4469-8358-6f75785098ae'
    },
    ClaimSubType: {
        OutPatient: 'e2f392fb-2752-4061-8895-4a881a71c7ba',
        InPatient: '14f75e87-bb8f-4af9-967a-c816350c7db5',
    },
    PreReason: {
        PendedOther: 'e1ee0fd1-be0a-4c97-b9b2-c4458406c179',
        RejectedOther: 'f3226bba-d531-46c0-8c38-08d6c6b11090',
        CancelledOther: 'e3b75a8a-d7db-4ddb-bb11-7c1aa8f89cf2'
    },
    ServiceType: {
        MedicationCodes: 'c2210885-b0c2-4402-816e-9cba8ad0b561',
        ScientificCodes: '5829d072-9b59-4595-b3be-3f8f061dec5b',
        HerbalAndVitaminCodes: 'b269f592-35e4-466b-be98-a583f7bd144a'
    },
    pharmacistSubstitute: {
        Others: 'cfeb731f-f0fa-4fe5-b248-a15dee17b7e6'
    },
    eligibilityType: {
        Offline: 'c0675da0-fc9b-4f45-9385-93ae62f9e4fa',
        Online: 'dab8f11c-388f-4da3-940e-dbdffb6e8453',
    },
    preauthDetailType: {
        Offline: 'c643ba6c-07b0-416f-a2f6-e28af0235f28',
        Online: '771ba8f3-b5ff-4744-8d61-e53c39f7328e',
    },
    DEFAULT_USERS: {
        SUPER_ADMIN: '48fefeea-a4ce-4ad1-a23f-ccf0a2304a5f',
        PAYER: 'ac477653-4150-4203-96b4-b33df0ba29ce',
        PROVIDER: '5ce172df-bb38-4a88-a2e3-8d58f33512e5'
    },
    DEFAULT_ROLES: {
        SUPER_ADMIN: '69dffa87-69a5-488d-8f80-2456ae9ef5b6',
        PAYER: '40619660-dbe5-4907-a23a-357cfd7209bb',
        PROVIDER: '97953a75-2ab4-44be-8a61-4fd444057e6d',
        PATIENT: '15268601-63e9-42a9-a7a7-8e3f3cbe2aca'
    },
    BILLING_TYPE: {
        REIMBURSEMENT_BILLING: 'bde60c94-27cc-42c0-9f67-abcceeb369c8',
        DIRECT_BILLING: 'a18f046f-68dd-41d7-857f-2500206481fa'
    },
    RELATION_TYPE: {
        PRIMARY: '3193561b-652a-4bb8-83f3-d896543a9585'
    }
};
